module.exports = __webpack_public_path__ + "static/media/icon-user.9f9d5a5e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/icon-user.svg
 ** module id = 318
 ** module chunks = 0
 **/